import React from "react";
import "../components/styles/Legal.scss";

function Terms() {
  return (
    <main className="legal-page">
      <div className="legal-container">
       <h1>Terms & Conditions</h1>

<p>
By accessing and using KalBridge services, you agree to comply with the following terms and conditions.
</p>

<h3>1. Services</h3>
<p>
KalBridge provides medical verification, documentation assistance, and physiotherapy coordination services for individuals applying for visas or requiring healthcare support.
</p>

<h3>2. User Responsibility</h3>
<p>
Users must provide accurate and complete information. KalBridge is not responsible for delays or issues caused by incorrect or incomplete data.
</p>

<h3>3. Medical Services</h3>
<p>
KalBridge acts as a facilitator and coordinator. Medical tests, evaluations, and treatments are conducted by authorized third-party medical professionals and institutions.
</p>

<h3>4. Payments</h3>
<p>
All service charges will be communicated before processing. Payments once made may be subject to specific refund policies depending on the service.
</p>

<h3>5. Limitation of Liability</h3>
<p>
KalBridge is not liable for:
</p>
<ul>
  <li>Medical outcomes or decisions made by healthcare providers</li>
  <li>Visa approval or rejection decisions</li>
  <li>Delays caused by third-party service providers</li>
</ul>

<h3>6. Appointment & Scheduling</h3>
<p>
Appointments are subject to availability. Users are responsible for attending scheduled visits and providing required documents.
</p>

<h3>7. Changes to Terms</h3>
<p>
KalBridge reserves the right to update these terms at any time without prior notice.
</p>

<h3>8. Contact</h3>
<p>
For any queries, please contact:
<br />
Email: info@kalbridge.com  
<br />
Phone: +91 9502451335
</p>
      </div>
    </main>
  );
}

export default Terms;